import { render, staticRenderFns } from "./Random.vue?vue&type=template&id=71fc7655&"
import script from "./Random.vue?vue&type=script&lang=js&"
export * from "./Random.vue?vue&type=script&lang=js&"
import style0 from "./Random.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports